import { BehaviorSubject, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs/operators';
import { LegacyBookInitService } from './legacy-book-initializer.service';
import { HttpService } from './http.service';
import { Reservation } from 'model/shared/backend-api-response/reservation';
import { CancelRoomUpdateResponse } from 'model/shared/backend-api-response/cancel-room-update-response';
import { BookRegCardResponse } from 'model/wbe/backend-api-response/book-reg-card-response';
import { ReservationStatusDetailsResponse } from 'model/wbe/backend-api-response/reservation-status-details-response';
import { GetCancelReasonListResponse } from 'model/wbe/backend-api-response/get-cancel-reason-list-response';

@Injectable()
export class ReservationService {
  public errorMessage: string;
  tenantId = this.configservice.gettenantId();
  propertyId = this.configservice.getpropertyId();
  property_name = this.configservice.PropertyData.PropNameKeyList.reservation;
  reg_property_name = this.configservice.PropertyData.PropNameKeyList.reservationcard;
  server_name = this.configservice.getserverReservation();
  cancelRoomProperty = this.configservice.PropertyData.PropNameKeyList.cancelroom;
  cancelRoomServerName = this.configservice.getServerRoomCancellation();
  arrivalDate;
  confirmatinNo;
  guestName;
  reservationData;
  checkValidateFIelds = new Subject();
  refreshReservation = new Subject();

  public resDetails = new BehaviorSubject<any>('resDetails');
  constructor(public _http: HttpClient, private configservice: LegacyBookInitService, public httpService: HttpService) {}
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
  setProperty(lastName, arrivalDate, confirmationNumber, result) {
    this.arrivalDate = arrivalDate;
    this.confirmatinNo = confirmationNumber;
    this.guestName = lastName;
    this.reservationData = result;
  }
  getConfigDetails(lastName, arrivalDate, confirmationNumber): Observable<Reservation | ArrayBuffer> {
    // confirmationNumber = confirmationNumber && encodeURIComponent(confirmationNumber);
    let locale = sessionStorage.getItem(`${this.tenantId}-${this.propertyId}-selectedLanguage`) || this.configservice.langCode;
    this.resDetails.next({
      lastName: lastName,
      arrivalDate: arrivalDate,
      confirmationNumber: confirmationNumber,
    });
    let url;

    url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      `propertyName/${this.property_name}/arriveDate/${arrivalDate}/guestName/${lastName}?appName=wbe&confirmation=${confirmationNumber}&locale=${locale}`;
    console.log(url);
    return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
      tap((data: Reservation) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }
  cancelRoom(reservationId): Observable<any[] | ArrayBuffer | CancelRoomUpdateResponse> {
    let url;
    url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      `propertyName/${this.cancelRoomProperty}/reservationID/${reservationId}?appName=wbe`;
    return this.httpService.put(url, {}, this.configservice.serviceHeaders).pipe(
      tap((data: CancelRoomUpdateResponse) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }

  cancelRoomWithReason(reservationId, data): Observable<any[] | ArrayBuffer> {
    let url;
    url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      `propertyName/${this.cancelRoomProperty}/reservationID/${reservationId}/cancelReservationWithReason?appName=wbe`;
    return this.httpService.put(url, data, this.configservice.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('cancelRoomResevation', []))
    );
  }

  getCancellationReasons(): Observable<GetCancelReasonListResponse> {
    const propertyName = this.configservice?.PropertyData?.PropNameKeyList?.cancellationCodes;
    let locale = sessionStorage.getItem(`${this.tenantId}-${this.propertyId}-selectedLanguage`) || this.configservice.langCode;
    let url = `${this.configservice.getCloudDomainName()}/wbe-reservation-service/reservation/tenants/${
      this.configservice.tenantId
    }/propertyId/${this.configservice.propertyId}/propertyName/${propertyName}/getCancellationCodes?locale=${locale}&appName=wbe`;
    return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
      tap((data) => console.log(data)),
      catchError(this.handleError('cancellationReasons', []))
    );
  }

  private errorHandle = (error) => {
    this.errorMessage = error.ErrorMessage;
  };

  getRegCard(arrivalDate, nights, reservationId): Observable<any[] | ArrayBuffer | BookRegCardResponse> {
    let url;
    url =
      this.configservice.getCloudDomainName() +
      '/' +
      this.server_name +
      '/tenants/' +
      this.tenantId +
      ('/context/' + this.configservice.PropertyData.ContextId + '/') +
      `propertyName/${this.reg_property_name}/resID/${reservationId}?appName=${this.configservice.appName}`;

    console.log(url);
    return this.httpService.get(url, this.configservice.serviceHeaders).pipe(
      tap((data: BookRegCardResponse) => console.log(data)),
      catchError(this.handleError('getOffers', []))
    );
  }

  getReservatiolStatuslist() {
    return this.httpService
      .get(
        this.configservice.getCloudDomainName() +
          '/wbe-property-service/reservationstatus/tenants/' +
          this.configservice.tenantId +
          `/getDetail?tenantId=${this.configservice.tenantId}&propertyId=${this.configservice.propertyId}&appName=${
            this.configservice.appName
          }&langId=${this.configservice.PropertyData.langCode.toLowerCase()}`,
        this.configservice.serviceHeaders
      )
      .pipe(tap((data: ReservationStatusDetailsResponse) => console.log(data)));
  }
}
